<div class="reports-page">
  <!-- Left Navigation -->
  <nav class="reports-page__nav">
    <div class="quarter-selector">
      <div class="mb-4">
        <small>Select Quarter</small>
      </div>
      <app-qep-dropdown [options]="quartersOfYear" [(ngModel)]="selectedQuarter" optionLabel="label" optionValue="value"
        placeholder="Select Quarter" type="outlined" (ngModelChange)="onQuarterChange($event)"
        [ngModelOptions]="{standalone: true}">
      </app-qep-dropdown>
    </div>
    <ng-container *ngFor="let group of reports">
      <ul>
        <li *ngFor="let report of group.reports" [class.active]="currentReport?.reportId === report.reportId">
          <a (click)="selectReport(report)">{{ report.title }}</a>
        </li>
      </ul>
    </ng-container>
  </nav>

  <!-- Right Content -->
  <main class="reports-page__content">
    <app-power-bi
      *ngIf="currentReport?.type === 'pbi' && !currentReport?.sharepointId"
      [report]="currentReport"
      [pageNavigationVisible]="isMultiPageReport"
      [filtersData]="filtersData"
      [slicersData]="slicersData"
      [selectedQuarter]="selectedQuarter"
      [quarterTableName]="quarterTableName">
    </app-power-bi>

    <doc-viewer *ngIf="currentReport?.sharepointId" [docType]="currentReport.type" [sharepointId]="sharepointId"
      [sharepointUrl]="sharepointUrl">
    </doc-viewer>

    <board-books *ngIf="currentReport?.type === 'pdfCollection'" [boardBooks]="boardBooks">
    </board-books>
  </main>
</div>